import Icon from './components/Icon';
import Svg from './svg/session-to-be-completed.svg';
export default props => <Icon component={Svg} data-name="ToBeCompletedIcon" {...props} />;